import { Text } from 'components/primitives/typography';
import { useAtomValue } from 'jotai';

export default function SelectedValuesCounter({ checkedValuesAtom }) {
  const checkedValues = useAtomValue<any[]>(checkedValuesAtom);

  if (checkedValues.length < 1) {
    return null;
  }

  return (
    <Text fWeight="600" fSize="16px" ml="8px">
      ({checkedValues.length})
    </Text>
  );
}
